module.exports = __webpack_public_path__ + "static/img/334156.5c1566ff.jpg";